export const MAX_CUSTOM_PAGES = 10;
export const DEFAULT_PAGE_TITLE = 'Custom page';
export const DEFAULT_DISPLAY_SCOPE = 'proposalOnly';
export const PDF_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10MB
export const isProposalAndAgreement = (page)=>page.displayScope === 'proposalAndAgreement';
export const agreementPages = (pages)=>pages.filter(isProposalAndAgreement).sort((a, b)=>a.displayOrder - b.displayOrder);
export const sortedPages = (pages)=>[
        ...pages
    ].sort((a, b)=>a.displayOrder - b.displayOrder);
/**
 * Full custom pages experience (rendering, editing, creation, template CRUD)
 * is enabled when FF is on OR when the entity already has custom pages
 * (from migration or from when FF was previously on).
 * When this returns true, behavior is identical regardless of FF state.
 */ export const customPagesEnabled = (ffEnabled, pages)=>ffEnabled || pages.length > 0;
